export class EnvService {

  // The values that are defined here are the default values that can
  // be overridden by env.js

  // API url
  public ApiUrl:string = 'https://api.dev-taly.io';
  public MerchantURL:string = 'https://dev-taly.io/partners/auth/login';
  public DocsURL:string = 'https://docs.taly.io/';
  public CareerURL:string = "https://boards.eu.greenhouse.io/taly";
  //sulaiman asked to remove temporary Kuwait Mobile ID
  //public appIOSURL:string = "https://apps.apple.com/us/app/kuwait-mobile-id-%D9%87%D9%88%D9%8A%D8%AA%D9%8A/id1449712307"
  //public appAndroidURL:string = "https://play.google.com/store/apps/details?id=kw.gov.paci.PACIMobileID&pcampaignid=web_share"
  public appIOSURL:string = "";
  public appAndroidURL:string = "";
  public applePayKey:string = "pk_live_A6wOTK***jugfZa25VhPXm";
  public knetCheckout:string = "https://test-gateway.mastercard.com/static/checkout/checkout.min.js";
  public applePayMerchantUrl:string = "https://dev-taly.io/apple-pay-session";
  public merchantIdentifier:string = "merchant.io.taly"

  // Whether or not to enable debug mode
  public enableDebug = true;
  public apiKey: string = ''; 

  constructor() {
  }

  onLinkClick(event: MouseEvent, appLink: string): void {
  if (!appLink || appLink.trim() === '') {
    event.preventDefault();
    return;
  }

  // Open link manually (optional)
  window.open(appLink, '_blank');
}

}
